import {useEffect, useState} from "react";
import {getInstrumentTableRows, InstrumentTableRow} from "../../../data/services/instrument-table-service";

export const getInstrumentRows = () => {
    const [rows, setRows] = useState<InstrumentTableRow[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        getInstrumentTableRows()
            .then(setRows)
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    return {rows, loading, error};
};
